import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { CapabilityEngineService } from '../capabilityEngine.service';

@Injectable()
export class TeamProfileService {


    constructor(
        private http: HttpClient,
        private _capEngineService: CapabilityEngineService
    ) { }

    getTeamDetails(teamId) {
        let header = this._capEngineService.getHeaders('viewTeamDetails');
        return this.http.get(environment.serverUrl + '/team/' + teamId, header);
    }
    updatingTeamDetails(objDetails, teamId) {
        let header = this._capEngineService.getHeaders('viewTeamDetails');
        return this.http.put(environment.serverUrl + '/team', objDetails, header);
    }
    deactivateTeam(teamId) {
        let header = this._capEngineService.getHeaders('deactivateTeam');
        return this.http.get(environment.serverUrl + '/team/deactivate' + teamId);
    }
    subscription(subscriptionValues) {
        return this.http.post(environment.serverUrl + '/payment/show', subscriptionValues);
    }
    subscribedDetails(){
        return this.http.get(environment.serverUrl + '/payment/subscriptions');
    }
    transectionDetail(){
        return this.http.get(environment.serverUrl + '/payment/transactions');
    }
    cancelSubscription(subscriptionObj){
        return this.http.post(environment.serverUrl + '/payment/subscriptions/cancel', subscriptionObj);
    }
    reactivateSubscription(subscriptionObj){
        return this.http.post(environment.serverUrl + '/payment/subscriptions/reactivate', subscriptionObj);
    }
    downlaodInvoicePdf(transactionId) {
        return this.http.post(environment.serverUrl + '/payment/subscriptions/invoice', {id: transactionId}, {responseType: 'blob'});
    }
}



// WEBPACK FOOTER //
// ./src/app/team-profile/team-profile.service.ts